<template>
	<div>
		<el-dialog width="290px" :visible.sync="selfType.show" :append-to-body="true" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false">
			<div class="self_tip_box">
				<div class="self_tip_title">
					Self Excluded 
					<img @click="close" class="self_tip_top_close_icon"
						src="../../../assets/icons/close_icon.png" alt="" />
				</div>
				<div class="self_tip_remark">
					<div class="">
						Your Self Exclusion will end on: {{$use.fromDate3(selfType.endTime)}} <br>
						Time
					</div>
					<div class="mar_t10">
						Please wait until the self exclusion period <br>
						ends before attempting to log in again.
					</div>
				</div>
				<div class="self_tip_price">
					Your Balance: ₦ {{user.totalAssets?user.totalAssets:0}}
				</div>
				
				<div @click="close" class="self_tip_btn">
					Continue
				</div>
				
				<div class="self_tip_kefu">
					Contact Customer Services
				</div>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		mapState,
	} from 'vuex';


	export default {
		name: 'selfextipdialog',
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		computed: {
			...mapState(['user', 'token','selfType']), // 映射 user 模块下的 userInfo 状态
		},
		data() {
			return {
				
			}
		},
		mounted() {


		},
		methods: {
			close() {
				this.$storag.setAccount()
				this.$storag.removeAllData()
				this.$store.dispatch('setSelfShow',false)
			},
			

		}
	}
</script>
<style scoped lang="scss">
	.self_tip_box {
		position: absolute;
		top: 0;
		left: 0;
		width: 290px;
		background: #1F242F;
		border-radius: 14px;
		box-sizing: border-box;
		padding: 36px 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.self_tip_title{
		font-size: 18px;
		color: #91A1BC;
	}
	
	.self_tip_remark{
		margin-top: 25px;
		font-weight: 400;
		font-size: 12px;
		color: #FFFFFF;
		line-height: 16px;
	}
	
	.self_tip_price{
		font-weight: 500;
		font-size: 16px;
		color: #F0F0F0;
		margin-top: 24px;
	}
	
	.self_tip_btn{
		width: 253px;
		height: 42px;
		background: linear-gradient( 95deg, #B2EB14 0%, #17CB67 25%, #19AB89 100%);
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 18px;
		color: #FFFFFF;
		margin: 35px auto 0;
		cursor: pointer;
	}
	
	.self_tip_kefu{
		font-weight: bold;
		font-size: 14px;
		color: #9AF19E;
		margin-top: 14px;
		cursor: pointer;
		text-decoration: underline;
	}
	
	.self_tip_top_close_icon{
		position: absolute;
		top: 20px;
		right: 20px;
		width: 33.38px;
		height: 33.38px;
		cursor: pointer;
	}
	
	
	
	
	
	
	
	
	
	
	
	
</style>